const HYSTERESIS_OFFSET = 20;

interface CalculateBreakpointValue {
  width: number;
  breakpoint: number;
  previousBreakpointValue: boolean;
  withHysteresis: boolean;
}

export const calculateBreakpointValue = ({
  width,
  breakpoint,
  previousBreakpointValue,
  withHysteresis
}: CalculateBreakpointValue) => {
  return previousBreakpointValue && withHysteresis
    ? width <= breakpoint + HYSTERESIS_OFFSET
    : width <= breakpoint;
};
